import { render, staticRenderFns } from "./authorizationModal.vue?vue&type=template&id=afd6aaa2"
import script from "./authorizationModal.vue?vue&type=script&lang=js"
export * from "./authorizationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports